import React from 'react';
import NumberFormat from 'react-number-format';

const CPFMaskedInput = (props: any) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      isNumericString
      format="###.###.###-##"
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
    />
  );
};

export default CPFMaskedInput;
